import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { get, ref } from "firebase/database";
import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { db } from "../Firebase";


const Header = () => {
  const [newsText, setNewsText] = useState("");
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    fetchNews();
    
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const fetchNews = async () => {
    try {
      const newsRef = ref(db, 'news/marqueeText');
      const snapshot = await get(newsRef);
      if (snapshot.exists()) {
        setNewsText(snapshot.val());
      }
    } catch (error) {
      console.error("Error fetching news:", error);
    }
  };

  const closeNavbar = () => {
    const navbarCollapse = document.getElementById('mainNavbar');
    if (navbarCollapse && navbarCollapse.classList.contains('show')) {
      const bsCollapse = window.bootstrap?.Collapse?.getInstance(navbarCollapse);
      if (bsCollapse) {
        bsCollapse.hide();
      } else {
        navbarCollapse.classList.remove('show');
      }
    }
  };
  
  return (
    <>
    <nav
      className={`navbar navbar-expand-lg navbar-light shadow-lg fixed-top ${isScrolled ? 'navbar-scrolled' : ''}`}
      style={{
        background: "#213F6D",
        zIndex: 1030,
        height: isScrolled ? "65px" : "75px",
        transition: "all 0.3s ease",
        backdropFilter: isScrolled ? "blur(10px)" : "none",
        borderBottom: "3px solid #1a3460"
      }}
    >
      <div
        className="container-fluid px-4"
        style={{ fontFamily: "'Inter', 'Segoe UI', sans-serif" }}
      >
        {/* Logo & Brand */}
        <div className="d-flex align-items-center">
          <div className="logo-container me-3" style={{
            transition: "transform 0.3s ease",
            cursor: "pointer"
          }}
          onMouseEnter={(e) => e.target.style.transform = "scale(1.05)"}
          onMouseLeave={(e) => e.target.style.transform = "scale(1)"}>
            <img 
              src="/Logo.png" 
              alt="Logo" 
              height={isScrolled ? "50" : "55"}
              style={{ 
                transition: "all 0.3s ease",
                filter: "drop-shadow(2px 2px 4px rgba(0,0,0,0.2))"
              }}
            />
          </div>
          
          <Link
            className="navbar-brand fw-bold d-flex align-items-center"
            to="/"
            style={{ 
              color: "#FFFFFF", 
              textShadow: "2px 2px 8px rgba(0,0,0,0.4)",
              textDecoration: "none",
              fontSize: isScrolled ? "1.3rem" : "1.5rem",
              transition: "all 0.3s ease"
            }}
          >
            
            <span className="brand-text" style={{color:"#FFFFFF"}}>जैन समग्र पोर्टल</span>
          </Link>
        </div>

        {/* Help Contact */}
        <div className="ms-4 d-none d-lg-flex align-items-center" style={{
          borderLeft: "2px solid rgba(255,255,255,0.3)",
          paddingLeft: "1.5rem"
        }}>
          <a 
            href="tel:9425006497"
            style={{
              color: "#FFFFFF",
              textDecoration: "none",
              fontSize: "0.95rem",
              fontWeight: "500",
              transition: "all 0.3s ease",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              padding: "8px 12px",
              borderRadius: "8px",
              backgroundColor: "transparent"
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "rgba(255, 255, 255, 0.2)";
              e.target.style.color = "#FFFFFF";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "transparent";
              e.target.style.color = "#FFFFFF";
            }}
          >
            <span>📞</span>
            <div style={{ textAlign: "left" }}>
              <div style={{ fontSize: "0.8rem", opacity: 0.9 }}>Contact Us</div>
              <div style={{ fontSize: "1rem", fontWeight: "bold" }}>9425006497</div>
            </div>
          </a>
        </div>

        {/* Mobile Toggle */}
        <button
          className="navbar-toggler border-0 shadow-none"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#mainNavbar"
          aria-controls="mainNavbar"
          aria-expanded="false"
          aria-label="Toggle navigation"
          style={{
            background: "rgba(255, 255, 255, 0.1)",
            borderRadius: "8px",
            padding: "8px 12px"
          }}
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Nav Links */}
        <div className="collapse navbar-collapse offcanvas-collapse" id="mainNavbar">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0 gap-1">
            {/* Home */}
            <li className="nav-item">
              <NavLink 
                className="nav-link px-3 py-2 nav-link-enhanced" 
                to="/"
                onClick={closeNavbar}
                style={({ isActive }) => ({
                  color: isActive ? "#000000" : "#FFFFFF",
                  background: isActive ? "#FFFFFF" : "transparent",
                  borderRadius: "6px",
                  fontWeight: isActive ? "600" : "400",
                  transition: "all 0.3s ease",
                  textDecoration: "none"
                })}
              >
                <span className="me-1">🏠</span> होम
              </NavLink>
            </li>

            {/* About */}
            <li className="nav-item">
              <NavLink 
                className="nav-link px-3 py-2 nav-link-enhanced" 
                to="/about"
                onClick={closeNavbar}
                style={({ isActive }) => ({
                  color: isActive ? "#000000" : "#FFFFFF",
                  background: isActive ? "#FFFFFF" : "transparent",
                  borderRadius: "6px",
                  fontWeight: isActive ? "600" : "400",
                  transition: "all 0.3s ease",
                  textDecoration: "none"
                })}
              >
                हमारे बारे में
              </NavLink>
            </li>

            {/* उद्देश्य */}
            <li className="nav-item">
              <NavLink 
                className="nav-link px-3 py-2 nav-link-enhanced" 
                to="/uddeshya"
                onClick={closeNavbar}
                style={({ isActive }) => ({
                  color: isActive ? "#000000" : "#FFFFFF",
                  background: isActive ? "#FFFFFF" : "transparent",
                  borderRadius: "6px",
                  fontWeight: isActive ? "600" : "400",
                  transition: "all 0.3s ease",
                  textDecoration: "none"
                })}
              >
                उद्देश्य
              </NavLink>
            </li>

            {/* Services Dropdown */}
            <li className="nav-item dropdown">
              <a 
                className="nav-link dropdown-toggle px-3 py-2 nav-link-enhanced" 
                href="#" 
                role="button" 
                data-bs-toggle="dropdown" 
                aria-expanded="false"
                style={{
                  color: "#FFFFFF",
                  background: "transparent",
                  fontWeight: "400",
                  transition: "all 0.3s ease",
                  textDecoration: "none",
                  border: "none"
                }}
              >
                सेवाएं
              </a>
              <ul className="dropdown-menu dropdown-menu-custom">
                <li><a className="dropdown-item" href="/coming-soon" onClick={(e) => { e.preventDefault(); closeNavbar(); window.location.href = '/coming-soon'; }}>जनगणना</a></li>
                <li><a className="dropdown-item" href="/coming-soon" onClick={(e) => { e.preventDefault(); closeNavbar(); window.location.href = '/coming-soon'; }}>जैन विवाह</a></li>
                <li><a className="dropdown-item" href="/coming-soon" onClick={(e) => { e.preventDefault(); closeNavbar(); window.location.href = '/coming-soon'; }}>डिजिटल निमंत्रण</a></li>
                <li><a className="dropdown-item" href="/coming-soon" onClick={(e) => { e.preventDefault(); closeNavbar(); window.location.href = '/coming-soon'; }}>जैन मंदिर प्रबंधन</a></li>
                <li><a className="dropdown-item" href="/coming-soon" onClick={(e) => { e.preventDefault(); closeNavbar(); window.location.href = '/coming-soon'; }}>जैन नौकरी आवश्यकताएं</a></li>
                <li><a className="dropdown-item" href="/coming-soon" onClick={(e) => { e.preventDefault(); closeNavbar(); window.location.href = '/coming-soon'; }}>जैन मंदिर / तीर्थ यात्रा</a></li>
                
                {/* जैन प्रोग्राम मैनेजमेंट - Multi-level */}
                <li className="dropdown-submenu">
                  <a className="dropdown-item dropdown-toggle" href="#">जैन कार्यक्रम प्रबंधन</a>
                  <ul className="dropdown-menu dropdown-submenu-menu">
                    <li><a className="dropdown-item" href="/coming-soon" onClick={(e) => { e.preventDefault(); closeNavbar(); window.location.href = '/coming-soon'; }}>पंचकल्याणक</a></li>
                    <li><a className="dropdown-item" href="/coming-soon" onClick={(e) => { e.preventDefault(); closeNavbar(); window.location.href = '/coming-soon'; }}>विधान</a></li>
                    <li><a className="dropdown-item" href="/coming-soon" onClick={(e) => { e.preventDefault(); closeNavbar(); window.location.href = '/coming-soon'; }}>शिविर</a></li>
                  </ul>
                </li>
                
                {/* जैन शिक्षा - Multi-level */}
                <li className="dropdown-submenu">
                  <a className="dropdown-item dropdown-toggle" href="#">जैन शिक्षा</a>
                  <ul className="dropdown-menu dropdown-submenu-menu">
                    <li><a className="dropdown-item" href="/coming-soon" onClick={(e) => { e.preventDefault(); closeNavbar(); window.location.href = '/coming-soon'; }}>जैन डिजिटल ऑनलाइन स्कूल</a></li>
                    <li><a className="dropdown-item" href="/coming-soon" onClick={(e) => { e.preventDefault(); closeNavbar(); window.location.href = '/coming-soon'; }}>जैन स्कूल</a></li>
                    <li><a className="dropdown-item" href="/coming-soon" onClick={(e) => { e.preventDefault(); closeNavbar(); window.location.href = '/coming-soon'; }}>जैन कॉलेज</a></li>
                    <li><a className="dropdown-item" href="/coming-soon" onClick={(e) => { e.preventDefault(); closeNavbar(); window.location.href = '/coming-soon'; }}>जैन संस्थान (आवासीय)</a></li>
                    <li><a className="dropdown-item" href="/coming-soon" onClick={(e) => { e.preventDefault(); closeNavbar(); window.location.href = '/coming-soon'; }}>जैन पुस्तकालय</a></li>
                  </ul>
                </li>
              </ul>
            </li>

            {/* Vishisht Panjikaran */}
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle px-3 py-2 nav-link-enhanced"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{ color: "#FFFFFF", background: "transparent", fontWeight: "400", transition: "all 0.3s ease", textDecoration: "none", border: "none" }}
              >
                🏅 विशिष्ठ पंजीयन
              </a>
              <ul className="dropdown-menu dropdown-menu-custom">
                <li>
                  <NavLink className="dropdown-item" to="/vishisht" onClick={closeNavbar}>
                    📋 विशिष्ठ सूची देखें
                  </NavLink>
                </li>
                <li>
                  <NavLink className="dropdown-item" to="/vishisht-panjikaran" onClick={closeNavbar}>
                    📝 पंजीयन करें
                  </NavLink>
                </li>
              </ul>
            </li>

            {/* Contact */}
            <li className="nav-item">
              <NavLink 
                className="nav-link px-3 py-2 nav-link-enhanced" 
                to="/contact"
                onClick={closeNavbar}
                style={({ isActive }) => ({
                  color: isActive ? "#000000" : "#FFFFFF",
                  background: isActive ? "#FFFFFF" : "transparent",
                  borderRadius: "6px",
                  fontWeight: isActive ? "600" : "400",
                  transition: "all 0.3s ease",
                  textDecoration: "none"
                })}
              >
                संपर्क करें
              </NavLink>
            </li>

            {/* Card */}
            <li className="nav-item">
              <NavLink 
                className="nav-link px-3 py-2 nav-link-enhanced" 
                to="/parivar-card"
                onClick={closeNavbar}
                style={({ isActive }) => ({
                  color: isActive ? "#000000" : "#FFFFFF",
                  background: isActive ? "#FFFFFF" : "transparent",
                  borderRadius: "6px",
                  fontWeight: isActive ? "600" : "400",
                  transition: "all 0.3s ease",
                  textDecoration: "none"
                })}
              >
                <span className="me-1">💳</span> कार्ड
              </NavLink>
            </li>

            {/* Login Button */}
            <li className="nav-item ms-2">
              <Link 
                to="/Select-login" 
                onClick={closeNavbar}
                className="btn btn-primary btn-sm px-4 py-2 fw-bold rounded-pill cta-button"
                style={{
                  color: '#FFFFFF',
                  backgroundColor: '#7d9cca',
                  borderColor: '#213F6D',
                  boxShadow: '0 4px 15px rgba(33, 63, 120, 0.3)',
                  transition: 'all 0.3s ease',
                  textDecoration: 'none'
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 6px 20px rgba(33, 63, 120, 0.5)';
                  e.target.style.backgroundColor = '#193264';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 4px 15px rgba(33, 63, 120, 0.3)';
                  e.target.style.backgroundColor = '#213F6D';
                }}
              >
                <span className="me-1">🔐</span> लॉगिन
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    
    {/* Enhanced News Marquee */}
    <div
      className="news-marquee"
      style={{
        background: "linear-gradient(135deg, #2A4980 0%, #213F6D 100%)",
        color: "#FFFFFF",
        fontWeight: "600",
        height: "45px",
        lineHeight: "45px",
        borderTop: "3px solid #2A4980",
        borderBottom: "3px solid #213F6D",
        letterSpacing: "0.5px",
        marginTop: isScrolled ? "65px" : "75px",
        transition: "margin-top 0.3s ease",
        boxShadow: "0 2px 10px rgba(42, 73, 128, 0.3)",
        position: "relative",
        overflow: "hidden"
      }}
    >
      <div className="marquee-gradient-left" style={{
        position: "absolute",
        left: 0,
        top: 0,
        width: "50px",
        height: "100%",
        background: "linear-gradient(90deg, rgba(42, 73, 128, 1) 0%, transparent 100%)",
        zIndex: 2
      }}></div>
      
      <marquee
        behavior="scroll"
        direction="left"
        scrollamount="3"
        style={{
          fontSize: "14px",
          fontFamily: "'Inter', sans-serif"
        }}
      >
        <span className="me-4" style={{ color: "#FFFFFF" }}>🎆</span>
        {newsText || "✨ जैन समुदाय को सशक्त बनाना - एक साथ ✨ \u00a0\u00a0|\u00a0\u00a0 🌟 अपने परिवार को रजिस्टर करें और डिजिटल कार्ड प्राप्त करें 🌟"}
        <span className="ms-4" style={{ color: "#FFFFFF" }}>🎆</span>
      </marquee>
      
      <div className="marquee-gradient-right" style={{
        position: "absolute",
        right: 0,
        top: 0,
        width: "50px",
        height: "100%",
        background: "linear-gradient(90deg, transparent 0%, rgba(42, 73, 128, 1) 100%)",
        zIndex: 2
      }}></div>
    </div>
    
    {/* Enhanced CSS Styles */}
    <style>{`
      .navbar-scrolled {
        backdrop-filter: blur(15px) !important;
      }
      
      .nav-link-enhanced:hover {
        background: rgba(255, 255, 255, 0.18) !important;
        transform: translateY(-1px);
        color: #FFFFFF !important;
        border-radius: 6px;
      }
      
      .cta-button:hover {
        color: #FFFFFF !important;
      }
      
      .brand-text {
        color: #FFFFFF;
      }
      
      .news-marquee {
        animation: newsGlow 3s ease-in-out infinite alternate;
      }
      
      /* Dropdown Styles */
      .dropdown-menu-custom {
        background: #FFFFFF;
        border: 2px solid #213F6D;
        border-radius: 12px;
        box-shadow: 0 8px 25px rgba(33, 63, 120, 0.2);
        backdrop-filter: blur(10px);
        padding: 8px 0;
        margin-top: 8px;
        min-width: 250px;
      }
      
      .dropdown-item {
        color: #333333;
        padding: 10px 20px;
        font-weight: 500;
        transition: all 0.3s ease;
        border-radius: 8px;
        margin: 2px 8px;
      }
      
      .dropdown-item:hover {
        background: #213F6D;
        color: #FFFFFF;
        transform: translateX(5px);
      }
      
      /* Multi-level dropdown */
      .dropdown-submenu {
        position: relative;
      }
      
      .dropdown-submenu .dropdown-menu {
        top: 0;
        left: 100%;
        margin-top: -1px;
        border-radius: 8px;
      }
      
      .dropdown-submenu:hover .dropdown-submenu-menu {
        display: block;
      }
      
      .dropdown-submenu-menu {
        display: none;
        position: absolute;
        background: #FFFFFF;
        border: 2px solid #CCCCCC;
        border-radius: 8px;
        box-shadow: 0 8px 25px rgba(204, 204, 204, 0.2);
        backdrop-filter: blur(10px);
        padding: 8px 0;
        min-width: 220px;
        z-index: 1000;
      }
      
      /* Mobile dropdown adjustments */
      @media (max-width: 991px) {
        .offcanvas-collapse {
          position: fixed;
          top: 0;
          left: -100%;
          width: 280px;
          height: 100vh;
          background: rgba(33, 63, 109, 0.98);
          padding: 1rem;
          box-shadow: 0 4px 15px rgba(0,0,0,0.2);
          transition: left 0.3s ease-in-out;
          z-index: 1040;
          overflow-y: auto;
        }
        
        .offcanvas-collapse.show {
          left: 0;
        }
        
        .nav-item {
          margin: 0.25rem 0;
        }
        
        .dropdown-menu-custom {
          border: none;
          background: rgba(255,255,255,0.95);
          margin-left: 1rem;
        }
        
        .dropdown-submenu .dropdown-submenu-menu {
          position: static;
          display: none;
          box-shadow: inset 0 2px 5px rgba(33, 63, 120, 0.1);
          margin-left: 20px;
          border-left: 3px solid #CCCCCC;
        }
        
        .dropdown-submenu.show .dropdown-submenu-menu {
          display: block;
        }
      }
      
      @keyframes newsGlow {
        0% { box-shadow: 0 2px 10px rgba(42, 73, 128, 0.3); }
        100% { box-shadow: 0 4px 20px rgba(42, 73, 128, 0.4); }
      }
      
      @media (max-width: 768px) {
        .navbar-brand {
          font-size: 1.1rem !important;
        }
        .brand-text {
          display: none;
        }
        .nav-link-enhanced {
          margin: 2px 0;
          text-align: center;
        }
        .navbar {
          padding: 8px 0 !important;
        }
      }
    `}</style>
    </>
  );
};

export default Header;




